import { render, staticRenderFns } from "./BalanceByTags.vue?vue&type=template&id=7c456495"
import script from "./BalanceByTags.vue?vue&type=script&lang=js"
export * from "./BalanceByTags.vue?vue&type=script&lang=js"
import style0 from "./BalanceByTags.vue?vue&type=style&index=0&id=7c456495&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports